import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

// import { setContext } from 'apollo-link-context'

//Adding layouts router.
const BlankLayout = () => import("@/layouts/BlankLayout")
const Layout1 = () => import("@/layouts/backend/Layout-1")

//Adding page content router.
const RFP = () => import('@/views/backend/Dashboards/RFP')
const RFPView = () => import('@/views/backend/Dashboards/RFPView')

//auth elements
const SignIn = () => import('@/views/backend/Auth/SignIn')
const SignUp = () => import('@/views/backend/Auth/SignUp')
const RecoverPassword = () => import('@/views/backend/Auth/RecoverPassword')

Vue.use(VueRouter)

const childRoute = () => [

   {
    path: 'my-rfps',
    name: 'my-rfps',
    meta: {
      name: 'my-rfps',
      requiresAuth: true,
      roles: ['REGION_MANAGER', 'OPERATIONS_LEAD', 'VALET', 'WASHER', 'MECHANIC', 'WORKSHOP']
    },
    component: RFP,
    props: {titleText: 'RFPs'},

  },
    {
    path: 'rfps-not-quoted',
    name: 'rfps-not-quoted',
    meta: {
      name: 'rfps-not-quoted',
      requiresAuth: true,
      roles: ['REGION_MANAGER', 'OPERATIONS_LEAD', 'VALET', 'WASHER', 'MECHANIC', 'WORKSHOP']
    },
    component: RFP,
    props: {titleText: 'Not Quoted RFPs', filterIsQuoted: false},
  },
  {
    path: 'rfps-partially-quoted',
    name: 'rfps-partially-quoted',
    meta: {
      name: 'rfps-partially-quoted',
      requiresAuth: true,
      roles: ['REGION_MANAGER', 'OPERATIONS_LEAD', 'VALET', 'WASHER', 'MECHANIC', 'WORKSHOP']
    },
    component: RFP,
    props: {titleText: 'Partially Quoted RFPs', filterIsQuoted: true, filterIsFullyQuoted: false},
  },
   {
    path: 'rfp/:rfpId',
    name: 'rfp-view',
    meta: {
      name: 'rfp-view',
      requiresAuth: true,
      roles: ['REGION_MANAGER', 'OPERATIONS_LEAD', 'VALET', 'WASHER', 'MECHANIC', 'WORKSHOP']
    },
    component: RFPView,
    props: true,
  },
 
]
const authchildRoute = () => [
  {
    path: 'sign-in',
    name: 'auth.login',
    meta: { name: 'SignIn' },
    component: SignIn
  },
  {
    path: 'sign-up',
    name: 'auth.register',
    meta: { name: 'SignUp' },
    component: SignUp
  },
  {
    path: 'recover-password',
    name: 'auth.recover-password',
    meta: { name: 'Recover Password' },
    component: RecoverPassword
  },
]

const routes = [
  {
    path: '/',
    name: '',
    component: Layout1,
    children: childRoute()
  },
  {
    path: '/auth',
    name: 'auth',
    component: BlankLayout,
    children: authchildRoute()
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})



const token = localStorage.getItem("apollo-token");
router.headers = {
  'accept': 'application/json',
  'content-type': 'application/json',

  'X-Client': process.env.VUE_APP_API_CLIENT,
  "authorization": 'JWT ' + token
}

const resize = () => {
  var ww = document.body.clientWidth;
  var body = document.body;
  if(document.body.classList.contains('sidebar-main')){
    if (ww < 1300) {
      // var body = document.body;
      body.classList.remove("sidebar-main");
    } else {
      //  var body = document.body;
      body.classList.add("sidebar-main");
    }
  }
}
router.beforeEach((to, from, next) => {
  //for hiding sidebar by default
  // const userDetails = JSON.parse(localStorage.getItem('user-details'))
  resize();
  let isUserLoggedIn
  if (localStorage.getItem("apollo-token") !== null) {
    isUserLoggedIn = true;
  }
  if (to.name === '') {
    next({
      path: '/my-rfps',
    })
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isUserLoggedIn) {
      store.dispatch('logOut')
      // router.push({ path: 'Onboarding' });
      next({
        path: '/auth/sign-in',
        // query: { redirect: to.fullPath }
      })
    } else {
      next()
      // if (to.meta?.roles?.includes(userDetails.jobProfile.type)) {
      //   next()
      // }
      // else {
      //   next('/pages/error-401')
      // }
    }
  }
  else {
    next()
  }
})

export default router
